// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"ProductHeader_productDetailHeader__x6Hs5","customIcon":"ProductHeader_customIcon__uqYcW"};